import { useRouter } from "next/router";
import styled from "styled-components";

import { bp, bpMax } from "theme";
import { Container, Section } from "../../styles/commonStyles";
import config from "../../config";
import Button from "../Buttons/Button";
import Mixpanel from "../../utils/Mixpanel";
import { getUrlPath } from "../../utils/helpers";
import StepOneIcon from "../../assets/svgs/StepOneIcon";
import StepTwoIcon from "../../assets/svgs/StepTwoIcon";
import StepThreeIcon from "../../assets/svgs/StepThreeIcon";
import StepFourIcon from "../../assets/svgs/StepFourIcon";

export type EmployerHeaderPropsType = {
	heading1: string;
	heading2?: string;
	subHeading: string;
};

const EmployerHeader: React.FC<EmployerHeaderPropsType> = ({
	heading1,
	heading2 = "",
	subHeading,
}) => {
	const router = useRouter();

	const trackEmployerPostJob = () => {
		Mixpanel.track("Employer page post a job click", {
			page: getUrlPath(),
		});
	};
	const trackEmployerLogin = () => {
		Mixpanel.track("Employer page Employer Login click", {
			page: getUrlPath(),
		});
	};
	return (
		<HeaderSection>
			<HeaderContainer>
				<HeaderWrapper>
					<HeaderTextHeadingContainer>
						{heading2 ? (
							<HeadingText>
								{heading1} <br /> {heading2}
								<br />
								<SubHead>{subHeading}</SubHead>
							</HeadingText>
						) : (
							<HeadingText>
								{heading1}
								<br />
								<SubHead> {subHeading}</SubHead>
							</HeadingText>
						)}
						<DesktopContainer>
							<PostJobBtn
								className="h-mobile"
								as="a"
								href={`${config.dashboardUrl}/login?utm_source=${
									(router.query && router.query.utm_source) || "Website"
								}&utm_medium=${
									(router.query && router.query.utm_medium) ||
									"Post%20Job%20Button"
								}&utm_campaign=${
									(router.query && router.query.utm_campaign) ||
									"EmployerPageHeader"
								}&employer=true`}
								id="cta-banner-job-typeform-btn"
								rel="noopener noreferrer"
								onClick={trackEmployerPostJob}
								target="_blank"
							>
								Post a job
							</PostJobBtn>
						</DesktopContainer>
						<MobileContainer>
							<ButtonWrapper>
								<PostJobBtn
									onClick={trackEmployerPostJob}
									className="h-mobile"
									as="a"
									target="_blank"
									href={`${config.dashboardUrl}/login?utm_source=${
										(router.query && router.query.utm_source) ||
										"Website"
									}&utm_medium=${
										(router.query && router.query.utm_medium) ||
										"Post%20Job%20Button"
									}&utm_campaign=${
										(router.query && router.query.utm_campaign) ||
										"EmployerPageHeader"
									}&employer=true`}
									rel="noopener noreferrer"
								>
									Post a Job now
								</PostJobBtn>
								<EmpLoginBtn
									className="h-mobile"
									as="a"
									target="_blank"
									href={`${config.dashboardUrl}/login?utm_source=${
										(router.query && router.query.utm_source) ||
										"Website"
									}&utm_medium=${
										(router.query && router.query.utm_medium) ||
										"Employer%20Login%20Button"
									}&utm_campaign=${
										(router.query && router.query.utm_campaign) ||
										"EmployerPageHeader"
									}&employer=true`}
									rel="noopener noreferrer"
									onClick={trackEmployerLogin}
								>
									Employer Login
								</EmpLoginBtn>
							</ButtonWrapper>
						</MobileContainer>
					</HeaderTextHeadingContainer>
					<StepContainer>
						<StepWrapper>
							<StepIconWrapper>
								<StepOneIcon />
							</StepIconWrapper>
							<StepText>Post your job in under 2 minutes</StepText>
						</StepWrapper>
						<StepWrapper>
							<StepIconWrapper>
								<StepTwoIcon />
							</StepIconWrapper>
							<StepText>Get the job reviewed over a call</StepText>
						</StepWrapper>
						<StepWrapper>
							<StepIconWrapper>
								<StepThreeIcon />
							</StepIconWrapper>
							<StepText>Start conducting interviews instantly</StepText>
						</StepWrapper>
						<StepWrapper>
							<StepIconWrapper>
								<StepFourIcon />
							</StepIconWrapper>
							<StepText>Get your hire within 48 hours</StepText>
						</StepWrapper>
					</StepContainer>
				</HeaderWrapper>
			</HeaderContainer>
		</HeaderSection>
	);
};

// styles
const DesktopContainer = styled.div`
	display: none;
	${bp.md} {
		display: block;
	}
`;
const MobileContainer = styled.div`
	display: block;
	${bp.md} {
		display: none;
	}
`;
const HeaderSection = styled(Section)`
	background-color: #4d3951;
	padding: 15px 0px 30px 0px;
`;
const HeaderContainer = styled(Container)``;
const HeaderWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	flex-wrap: wrap;
	${bp.lg} {
		flex-direction: row;
		justify-content: space-between;
	}
`;
const HeaderTextHeadingContainer = styled.div`
	margin: auto 0px;
	display: flex;
	flex-direction: column;
	align-items: center;
	${bp.md} {
		flex-direction: row;
		justify-content: space-between;
	}
	${bp.lg} {
		flex-direction: column;
		align-items: flex-start;
	}
`;
const HeadingText = styled.h1`
	flex: 1;
	font-weight: 800;
	font-size: 24px;
	color: #ffffff;
	margin-bottom: 15px;
	text-align: center;

	${bp.md} {
		font-size: 40px;
		text-align: left;
		margin-bottom: 0;
	}
`;
const SubHead = styled.span`
	font-size: 24px;
	font-weight: 800;
	color: #2bb793;
	margin: 0;
	${bp.md} {
		flex: 1;
		display: block;
		font-size: 40px;
		margin-bottom: 26px;
	}
`;

const StepContainer = styled.div`
	margin-top: 20px;
	display: flex;
	align-items: stretch;
	justify-content: space-between;
	flex-wrap: wrap;
	${bpMax.md} {
		justify-content: space-around;
	}
`;
const StepWrapper = styled.div`
	max-width: 128px;
	margin: 0px 15px;
	${bpMax.sm} {
		max-width: 100px;
		margin: 0px 15px 15px 15px;
	}
`;
const StepIconWrapper = styled.div`
	height: 128px;
	display: flex;
	align-items: center;
	& svg {
		height: 100%;
	}
	${bpMax.sm} {
		height: 100px;
	}
`;
const StepText = styled.div`
	margin-top: 15px;
	font-size: 16px;
	text-align: center;
	color: #ffffff;
	line-height: 22px;
	${bpMax.md} {
		font-size: 12px;
		line-height: 1.43;
	}
`;

const PostJobBtn = styled(Button)`
	border-radius: 4px;
	background-color: #2bb793;
	font-size: 14px;
	font-weight: 900;
	color: #ffffff;
	padding: 0px 15px;
	border: none;
	outline: none;
	line-height: 32px;
	height: 32px;
	text-decoration: none;
	&:hover {
		box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.39);
	}
	${bp.md} {
		font-size: 20px;
		padding: 6px 40px;
		height: 46px;
	}
`;
const EmpLoginBtn = styled(Button)`
	height: 32px;
	background-color: #4d3951;
	font-size: 14px;
	font-weight: 900;
	padding: 0px 14px;
	border: 1px solid #ffffff;
	outline: none;
	color: #ffffff;
	line-height: 32px;
	text-decoration: none;
	border-radius: 4px;
	&:hover {
		box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.39);
		border: none;
	}
	${bpMax.md} {
		font-size: 14px;
		padding: 0px 15px;
	}
`;
const ButtonWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 30px;
	& ${PostJobBtn} {
		margin-right: 15px;
	}
`;
export default EmployerHeader;
